import { type Stop, hasAddress } from '../domain/Stop'
import { type StopInfo } from '../domain/StopInfo'
import { formatDate, isDateOnly } from '../utils/date'
import { isNotEmpty, isString } from '../utils/string'

export function getStopAddress(stop: Stop): string {
  if (hasAddress(stop)) {
    const location = getStopLocation(stop)
    return stop.address!.replace(new RegExp(`, ${location}$`), '')
  }

  return ''
}

export function getStopDescription({ city, state }: Stop) {
  return `${city}, ${state}`
}

export function getStopFormattedDate(stop: Stop): string {
  if (stop.date) {
    const date = isDateOnly(stop.date) ? `${stop.date}T23:59:59.999Z` : stop.date
    return formatDate(new Date(date), 'EEE, MMM dd')
  }

  return ''
}

export function getStopFormattedTime(stop: Stop): string {
  if (stop.date && !isDateOnly(stop.date)) {
    return formatDate(new Date(stop.date), 'HH:mm')
  }

  return ''
}

export function getStopLocation(stop: Stop): string {
  const stateAndZip = [stop.state, stop.zipCode].filter(isString).filter(isNotEmpty).join(' ')
  return [stop.city, stateAndZip, stop.country].filter(isString).filter(isNotEmpty).join(', ')
}

export function getStopTagLabel(isPickup: boolean, isDelivery: boolean) {
  if (isPickup) return 'Pickup'
  if (isDelivery) return 'Delivery'
  return 'Stop'
}

export function getStopInfoArrayFromStops(stops: Array<Stop>): Array<StopInfo> {
  return stops.map(s => ({
    stopSubtitle: `ZIP ${s.zipCode}`,
    stopTitle: getStopDescription(s),
  }))
}
